
import React from "react";
import { PartFilter } from "@/data/parts";
import { Badge } from "@/components/ui/badge";

interface FiltersCellProps {
  filters: PartFilter[];
  activeFilters: PartFilter[];
  onFilterClick: (filter: PartFilter) => void;
}

const FiltersCell = ({ filters, activeFilters, onFilterClick }: FiltersCellProps) => {
  return (
    <div className="flex flex-wrap gap-1 justify-between">
      {filters.map(filter => (
        <Badge 
          key={filter} 
          variant={activeFilters.includes(filter) ? "default" : "outline"}
          className="bg-transparent cursor-pointer hover:opacity-80 transition-opacity border-0"
          onClick={() => onFilterClick(filter)}
        >
          {filter}
        </Badge>
      ))}
    </div>
  );
};

export default FiltersCell;
